import { render, staticRenderFns } from "./RestBreakButton.vue?vue&type=template&id=d4ee4ee6&"
import script from "./RestBreakButton.vue?vue&type=script&lang=js&"
export * from "./RestBreakButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports